module.exports = __webpack_public_path__ + "img/timetable-conference.bdb5b8c1.png";